module.exports = __webpack_public_path__ + "media/images/icon_like-670e9c223ab21a85f1c6c9cbc722277c.svg";